// This component is used to render the enrichment section in the notification message section in the alert rule form

import { ComponentType } from 'react';

export interface EnrichmentSectionProps {}

export const EnrichmentSection: ComponentType<EnrichmentSectionProps> = () => {
  return null;
};
